import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from './block/table';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {ReactComponent as ArrowDown} from '../../../../../@casino/img/down-arrow.svg';
import {columns, getRows, useStyles} from './helpers';
import { setGetJackpotHistoryList } from '../../store/thunk/setGetJackpotHistoryList';

const BlockJackpot = ({profile}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {login} = profile;

    const [bonuses, setBonuses] = React.useState(false);

    React.useEffect(() => {
        if (bonuses) {
            dispatch(setGetJackpotHistoryList({
                page: 1,
                rowsPerPage: 10,
                search: login,
                date_from: 0,
                date_to: new Date().getTime(),
            }))
        }
    }, [bonuses, login]);

    const jackpot = useSelector(state => state.users.list_jackpot);
    const rows = React.useMemo(() => getRows(jackpot.data), [jackpot])
    
    return (
        <div>
            <div 
                className={classes.wrapTitle}
                onClick={() => {
                    setBonuses(!bonuses)
                }}
            >
                <span
                    className={classes.title}
                >
                    Джекпоты
                </span>
                {
                    !bonuses && 
                    <ArrowRight className={classes.arrow}/>
                }
                {
                    bonuses && 
                    <ArrowDown className={classes.arrow}/> 
                }        
            </div>
            {
                bonuses && (
                    <div>
                        <TableCasino
                                allPage={jackpot.count}
                                width={1280}
                                perPage={10}
                                columns={columns}
                                rows={rows}
                                changeRowsPerPage={(v) => dispatch(setGetJackpotHistoryList({
                                    page: 1,
                                    rowsPerPage: v.rowsPerPage,
                                    search: profile.login,
                                    date_from: 0,
                                    date_to: new Date().getTime(),
                                }))}
                        /> 
                    </div>
                )
            }
        </div>
    )
}

export default BlockJackpot;